// Metadata is read independently of the editor's visible player, so importing
// works from Paper edit without forcing the user into Transcript mode.
export function readVideoMetadata(file) {
  return new Promise((resolve,reject) => {
    const video=document.createElement('video');
    const url=URL.createObjectURL(file);
    const finish=(error,value)=>{
      clearTimeout(timer);video.onloadedmetadata=null;video.onerror=null;
      video.removeAttribute('src');video.load();URL.revokeObjectURL(url);
      if(error)reject(error);else resolve(value);
    };
    const timer=setTimeout(()=>finish(new Error('Could not read this video. Try a browser-compatible MP4 or WebM.')),15000);
    video.preload='metadata';
    video.onloadedmetadata=()=>{
      if(!Number.isFinite(video.duration) || video.duration<=0 || !video.videoWidth)return finish(new Error('This file has no readable video metadata.'));
      finish(null,{duration:video.duration,width:video.videoWidth,height:video.videoHeight});
    };
    video.onerror=()=>finish(new Error('This browser cannot read the video. Try an MP4 with H.264 video and AAC audio.'));
    video.src=url;
  });
}


/**
 * Check the container's audio-track metadata without decoding or uploading the
 * entire file. Returns null when this browser cannot inspect the container:
 * unknown is not equivalent to a video with no audio.
 */
export async function hasInterviewAudioTrack(file) {
  if (!file) return null;
  let input;
  try {
    const {Input,ALL_FORMATS,BlobSource}=await import('mediabunny');
    input=new Input({formats:ALL_FORMATS,source:new BlobSource(file)});
    if(!await input.canRead())return null;
    const tracks=await input.getAudioTracks();
    return tracks.length>0;
  }catch{
    // Unsupported/partially written formats still get the provider's diagnosis.
    return null;
  }finally{
    input?.dispose();
  }
}
